// extracted by mini-css-extract-plugin
module.exports = {"customTooltip":"tooltip-warning_customTooltip__3aQuQ","customArrow":"tooltip-warning_customArrow__1wZON"};